import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useBalanceSheet, useClient } from '../../api';
import { ChartNavigator, WealthOverviewTotalData } from '../../components/wealth';
import { BalanceSheet } from '../../components/wealth/balanceSheet/BalanceSheet';
import { WealthProvider } from '../../contexts/wealth-context';

export const WealthOverviewScreen: FunctionComponent = () => {
    const { t } = useTranslation();
    const { data: client } = useClient();
    const { isLoading, isSuccess } = useBalanceSheet();

    return (
        <>
            <div style={{ flex: 1, position: 'relative', minWidth: 0 }}>
                <div className={`wealth-overview ${isLoading ? 'shimmer' : ''}`}>
                    <h4>{t('titleWealth')}</h4>
                    {isSuccess && (
                        <WealthProvider>
                            <div className="wealth-overview__content">
                                <WealthOverviewTotalData clientCurrency={client?.currency} />
                                <div className="wealth-overview__sub-content">
                                    <ChartNavigator />
                                    <div className="wealth-overview__balance-sheet-container">
                                        <BalanceSheet />
                                    </div>
                                </div>
                            </div>
                        </WealthProvider>
                    )}
                </div>
            </div>
        </>
    );
};
